export default __webpack_public_path__ + "static/media/Motorola Moto Z.421bb1b9.png";